import { parse } from 'date-fns';
import { enUS, frCA } from 'date-fns/locale';

const locales = { en: enUS, fr: frCA };

export default (dateString, formatString, referenceDate, options = {}) =>
  parse(dateString, formatString, referenceDate, {
    ...options,
    locale: locales[window.i18nLang],
  });
